import { useCallback } from "react";
import { getLowerCaseString } from "helpers/function";

export const useSearch = (claimObject) => {
  const matchToClaimObjectOrEntity = useCallback((list, value) => {
    let match = false;
    list.forEach((el) => {
      match =
        match ||
        getLowerCaseString(el.name["fr"]).indexOf(value) >= 0 ||
        (el.units ? matchToClaimObjectOrEntity(el.units, value) : false);
    });
    return match;
  }, []);

  const filterBySearchValue = useCallback(
    (value) => {
      const searchValue = getLowerCaseString(value);
      let filteredClaimObject = [...claimObject];

      filteredClaimObject = filteredClaimObject.filter(
        (el) =>
          getLowerCaseString(el.name["fr"]).indexOf(searchValue) >= 0 ||
          matchToClaimObjectOrEntity(el.claim_objects, searchValue)
      );

      return filteredClaimObject;
    },
    [claimObject, matchToClaimObjectOrEntity]
  );

  const searchElement = useCallback(
    (searchValue) => {
      if (searchValue && searchValue.trim()) {
        return filterBySearchValue(searchValue);
      } else {
        return claimObject;
      }
    },
    [claimObject, filterBySearchValue]
  );

  return {
    searchElement,
    filterBySearchValue,
  };
};
